import React from 'react'

const AuditLogIcon = () => {
    return (
        <div><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 10C2.49844 11.7175 3.08642 13.3836 4.16569 14.7197C5.24496 16.0558 6.75011 16.9809 8.42957 17.3406C10.109 17.7002 11.8611 17.4725 13.3928 16.6955C14.9246 15.9186 16.1432 14.6394 16.8451 13.0718C17.547 11.5043 17.6896 9.74326 17.2491 8.08317C16.8086 6.42309 15.8116 4.9645 14.4248 3.95119C13.038 2.93788 11.3455 2.43125 9.63004 2.51597C7.91458 2.6007 6.28018 3.27164 5 4.41667L2.5 6.66667" stroke="#DCC5A0" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2.5 2.5V6.66667H6.66667" stroke="#DCC5A0" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10 5.8335V10.0002L13.3333 11.6668" stroke="#DCC5A0" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        </div>
    )
}

export default AuditLogIcon